// Ícones ultra-avançados
import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { reactPost, comment } from "../../../functions/post";
import { FeedPostMenu } from "../shared";

const ARIcon = () => (<svg width="24" height="24" fill="currentColor"><circle cx="12" cy="12" r="10"/><text x="7" y="17" fontSize="10" fill="#fff">AR</text></svg>);
const ChallengeIcon = () => (<svg width="24" height="24" fill="currentColor"><rect x="4" y="4" width="16" height="16" rx="4"/><text x="6" y="17" fontSize="10" fill="#fff">🏆</text></svg>);
const LiveIcon = () => (<svg width="24" height="24" fill="red"><circle cx="12" cy="12" r="10"/><text x="7" y="17" fontSize="10" fill="#fff">LIVE</text></svg>);
const PrivacyIcon = () => (<svg width="24" height="24" fill="currentColor"><rect x="4" y="8" width="16" height="10" rx="2"/><circle cx="12" cy="13" r="3" fill="#fff"/></svg>);
const NotificationIcon = () => (<svg width="24" height="24" fill="currentColor"><path d="M12 22c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2zm6-6V11c0-3.07-1.63-5.64-4.5-6.32V4a1.5 1.5 0 0 0-3 0v.68C7.63 5.36 6 7.92 6 11v5l-1.7 1.7c-.14.14-.3.33-.3.6V19h16v-1.7c0-.27-.16-.46-.3-.6L18 16z"/></svg>);
const ModerationIcon = () => (<svg width="24" height="24" fill="orange"><rect x="4" y="4" width="16" height="16" rx="2"/><text x="6" y="17" fontSize="10" fill="#fff">MOD</text></svg>);
const APIIcon = () => (<svg width="24" height="24" fill="blue"><rect x="4" y="4" width="16" height="16" rx="2"/><text x="6" y="17" fontSize="10" fill="#fff">API</text></svg>);
  // Ultra-avançados
  const handleAR = () => {
    alert("Abrir efeitos AR para este vídeo (integração WebAR/Snap)");
  };
  const handleChallenge = () => {
    alert("Participar ou criar desafio para este vídeo");
  };
  const handleLive = () => {
    alert("Iniciar ou assistir live deste usuário");
  };
  const handlePrivacy = () => {
    alert("Configurar privacidade granular deste post");
  };
  const handleNotification = () => {
    alert("Gerenciar notificações em tempo real deste post");
  };
  const handleModeration = () => {
    alert("Ver status de moderação automática/manual deste post");
  };
  const handleAPI = () => {
    alert("Importar ou integrar com APIs externas para este post");
  };

const StarIcon = () => (<svg width="24" height="24" fill="currentColor"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>);
const FlagIcon = () => (<svg width="24" height="24" fill="currentColor"><path d="M4 4h16v2H4zm0 4h10v2H4zm0 4h16v2H4zm0 4h10v2H4z"/></svg>);
const RemixIcon = () => (<svg width="24" height="24" fill="currentColor"><circle cx="12" cy="12" r="10"/><path d="M8 12h8M12 8v8" stroke="#fff" strokeWidth="2"/></svg>);
const DuetIcon = () => (<svg width="24" height="24" fill="currentColor"><rect x="4" y="4" width="7" height="16"/><rect x="13" y="4" width="7" height="16"/></svg>);
const SoundIcon = () => (<svg width="24" height="24" fill="currentColor"><path d="M3 9v6h4l5 5V4L7 9H3z"/><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02z"/></svg>);
const TemplateIcon = () => (<svg width="24" height="24" fill="currentColor"><rect x="4" y="4" width="16" height="16" rx="2"/><path d="M4 9h16" stroke="#fff" strokeWidth="2"/></svg>);
const RepostIcon = () => (<svg width="24" height="24" fill="currentColor"><path d="M17 1l4 4-4 4V6H3V4h14V1zM7 23l-4-4 4-4v3h14v2H7v3z"/></svg>);
const AnalyticsIcon = () => (<svg width="24" height="24" fill="currentColor"><rect x="4" y="10" width="3" height="10"/><rect x="10" y="4" width="3" height="16"/><rect x="16" y="7" width="3" height="13"/></svg>);

export default function TikTokCard({ post, user, isActive, onEdit, onPostDeleted }) {
  const [playing, setPlaying] = useState(false);
  const [muted, setMuted] = useState(true);
  const [liked, setLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(0);
  const [showComments, setShowComments] = useState(false);
  const [commentText, setCommentText] = useState("");
  const videoRef = useRef(null);

  const videoUrl = post.videos?.[0]?.url || post.images?.[0]?.url;
  const tiktokData = post.tiktokData || {};

  useEffect(() => {
    if (isActive && videoRef.current) {
      videoRef.current.play().catch(() => {});
      setPlaying(true);
    } else if (videoRef.current) {
      videoRef.current.pause();
      setPlaying(false);
    }
  }, [isActive]);

  const togglePlay = () => {
    if (videoRef.current) {
      if (playing) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setPlaying(!playing);
    }
  };

  const toggleMute = (e) => {
    e.stopPropagation();
    if (videoRef.current) {
      videoRef.current.muted = !muted;
      setMuted(!muted);
    }
  };


  // Handlers avançados
  const handleLike = async () => {
    await reactPost(post._id, "like", user.token);
    setLiked(!liked);
    setLikeCount(liked ? likeCount - 1 : likeCount + 1);
  };

  const handleFavorite = async () => {
    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/favoritePost`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${user.token}` },
        body: JSON.stringify({ postId: post._id })
      });
      // Atualize o estado conforme necessário
    } catch (e) { alert("Erro ao favoritar"); }
  };

  const handleReport = async () => {
    const motivo = prompt("Descreva o motivo da denúncia:");
    if (!motivo) return;
    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/reportPost`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${user.token}` },
        body: JSON.stringify({ postId: post._id, reason: motivo })
      });
      alert("Denúncia enviada!");
    } catch (e) { alert("Erro ao denunciar"); }
  };

  const handleRemix = () => {
    window.location.href = `/remix?postId=${post._id}`;
  };
  const handleDuet = () => {
    window.location.href = `/duet?postId=${post._id}`;
  };
  const handleUseSound = () => {
    window.location.href = `/create?soundId=${tiktokData?.soundId}`;
  };
  const handleUseTemplate = () => {
    window.location.href = `/create?templateId=${tiktokData?.templateId}`;
  };
  const handleRepost = async () => {
    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/repostPost`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${user.token}` },
        body: JSON.stringify({ postId: post._id })
      });
      alert("Vídeo republicado!");
    } catch (e) { alert("Erro ao republicar"); }
  };
  const handleAnalytics = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/postAnalytics/${post._id}`, {
        headers: { Authorization: `Bearer ${user.token}` }
      });
      const data = await res.json();
      alert("Visualizações: " + data.views + " | Curtidas: " + data.likes);
    } catch (e) { alert("Erro ao buscar analytics"); }
  };

  const handleComment = async () => {
    if (!commentText.trim()) return;
    await comment(post._id, commentText, user.token);
    setCommentText("");
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: post.text || "Vídeo do TikTok",
          url: window.location.origin + `/post/${post._id}`,
        });
      } catch (err) {
        console.log("Share cancelled");
      }
    }
  };

  return (
    <div className="tiktok_card">
      <div className="tiktok_video_container" onClick={togglePlay}>
        {videoUrl ? (
          <video
            ref={videoRef}
            src={videoUrl}
            loop
            muted={muted}
            playsInline
            className="tiktok_video"
          />
        ) : (
          <div className="tiktok_no_video">
            <span>Vídeo não disponível</span>
          </div>
        )}

        {!playing && (
          <div className="tiktok_play_overlay">
            <svg viewBox="0 0 24 24" fill="white" width="60" height="60">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        )}
      </div>

      {/* Actions Sidebar - AVANÇADO */}
      <div className="tiktok_actions">
        <FeedPostMenu
          post={post}
          onEdit={onEdit}
          onPostDeleted={onPostDeleted}
        />

        <Link to={`/profile/${post.user.username}`} className="tiktok_avatar">
          <img src={post.user.picture} alt="" />
          <div className="tiktok_avatar_plus">+</div>
        </Link>

        {/* Curtir */}
        <button className={`tiktok_action ${liked ? "liked" : ""}`} onClick={handleLike}>
          <svg viewBox="0 0 24 24" fill={liked ? "#fe2c55" : "white"}>
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
          </svg>
          <span>{likeCount || post.comments?.length || 0}</span>
        </button>

        {/* Favoritar */}
        <button className="tiktok_action" onClick={handleFavorite}>
          <StarIcon />
        </button>

        {/* Reportar */}
        <button className="tiktok_action" onClick={handleReport}>
          <FlagIcon />
        </button>

        {/* Remix */}
        <button className="tiktok_action" onClick={handleRemix} title="Remixar">
          <RemixIcon />
        </button>

        {/* Duet */}
        <button className="tiktok_action" onClick={handleDuet} title="Duet">
          <DuetIcon />
        </button>

        {/* Usar Som */}
        <button className="tiktok_action" onClick={handleUseSound} title="Usar Som">
          <SoundIcon />
        </button>

        {/* Usar Modelo */}
        <button className="tiktok_action" onClick={handleUseTemplate} title="Usar Modelo">
          <TemplateIcon />
        </button>

        {/* Republicar */}
        <button className="tiktok_action" onClick={handleRepost} title="Republicar">
          <RepostIcon />
        </button>

        {/* Analytics */}
        <button className="tiktok_action" onClick={handleAnalytics} title="Analytics">
          <AnalyticsIcon />
        </button>

        {/* Comentários */}
        <button className="tiktok_action" onClick={() => setShowComments(!showComments)}>
          <svg viewBox="0 0 24 24" fill="white">
            <path d="M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z" />
          </svg>
          <span>{post.comments?.length || 0}</span>
        </button>

        {/* Compartilhar */}
        <button className="tiktok_action" onClick={handleShare}>
          <svg viewBox="0 0 24 24" fill="white">
            <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z" />
          </svg>
          <span>{post.shares?.length || 0}</span>
        </button>

        {/* AR */}
        <button className="tiktok_action" onClick={handleAR} title="Efeitos AR">
          <ARIcon />
        </button>

        {/* Desafio */}
        <button className="tiktok_action" onClick={handleChallenge} title="Desafio">
          <ChallengeIcon />
        </button>

        {/* Live */}
        <button className="tiktok_action" onClick={handleLive} title="Live">
          <LiveIcon />
        </button>

        {/* Privacidade */}
        <button className="tiktok_action" onClick={handlePrivacy} title="Privacidade">
          <PrivacyIcon />
        </button>

        {/* Notificações */}
        <button className="tiktok_action" onClick={handleNotification} title="Notificações">
          <NotificationIcon />
        </button>

        {/* Moderação */}
        <button className="tiktok_action" onClick={handleModeration} title="Moderação">
          <ModerationIcon />
        </button>

        {/* APIs externas */}
        <button className="tiktok_action" onClick={handleAPI} title="APIs externas">
          <APIIcon />
        </button>

        {/* Mute */}
        <button className="tiktok_action" onClick={toggleMute}>
          {muted ? (
            <svg viewBox="0 0 24 24" fill="white">
              <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z" />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="white">
              <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
            </svg>
          )}
        </button>
      </div>

      {/* Bottom Info */}
      <div className="tiktok_info">
        <Link to={`/profile/${post.user.username}`} className="tiktok_username">
          @{post.user.username}
        </Link>
        <p className="tiktok_description">{post.text}</p>
        {tiktokData.hashtags?.length > 0 && (
          <div className="tiktok_hashtags">
            {tiktokData.hashtags.map((tag, i) => (
              <span key={i}>#{tag} </span>
            ))}
          </div>
        )}
        {tiktokData.musicTitle && (
          <div className="tiktok_music">
            <svg viewBox="0 0 24 24" fill="white" width="14" height="14">
              <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z" />
            </svg>
            <span className="tiktok_music_scroll">
              {tiktokData.musicTitle} - {tiktokData.musicArtist || "Original"}
            </span>
          </div>
        )}
      </div>

      {/* Comments Panel */}
      {showComments && (
        <div className="tiktok_comments_panel">
          <div className="tiktok_comments_header">
            <span>{post.comments?.length || 0} comentários</span>
            <button onClick={() => setShowComments(false)}>✕</button>
          </div>
          <div className="tiktok_comments_list">
            {post.comments?.map((c, i) => (
              <div key={i} className="tiktok_comment">
                <img src={c.commentBy?.picture} alt="" />
                <div className="tiktok_comment_content">
                  <span className="tiktok_comment_user">
                    {c.commentBy?.first_name} {c.commentBy?.last_name}
                  </span>
                  <p>{c.text}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="tiktok_comment_input">
            <input
              type="text"
              placeholder="Adicionar comentário..."
              value={commentText}
              onChange={(e) => setCommentText(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && handleComment()}
            />
            <button onClick={handleComment}>Enviar</button>
          </div>
        </div>
      )}
    </div>
  );
}
